// Leitura/gravação segura do carrinho no navegador e identidade exata de cada linha.
// Sem dependências de React para poder ser testado isoladamente.

export interface StoredCartLine {
  id: string | number;
  name: string;
  size: string;
  price: number;
  quantity: number;
  colorVariantId?: string;
  sizeVariantId?: string;
  [key: string]: unknown;
}

/** Acesso ao armazenamento local que nunca derruba a tela (modo privado, cota cheia, bloqueio). */
export const safeStorage = {
  get(key: string): string | null {
    try { return typeof window === "undefined" ? null : window.localStorage.getItem(key); } catch { return null; }
  },
  set(key: string, value: string): boolean {
    try { window.localStorage.setItem(key, value); return true; } catch { return false; }
  },
  remove(key: string): void {
    try { window.localStorage.removeItem(key); } catch { /* ignora */ }
  },
};

/** Lê o carrinho salvo descartando itens inválidos. */
export function parseStoredCart(raw: string | null): StoredCartLine[] {
  try {
    const parsed = JSON.parse(raw || "[]");
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((i: any) =>
      i && (typeof i.id === "string" || typeof i.id === "number") &&
      typeof i.name === "string" && typeof i.size === "string" &&
      Number.isFinite(i.price) && i.price >= 0 && Number.isInteger(i.quantity) && i.quantity > 0 &&
      (i.colorVariantId === undefined || typeof i.colorVariantId === "string") &&
      (i.sizeVariantId === undefined || typeof i.sizeVariantId === "string"));
  } catch {
    return [];
  }
}

/** Lê a embalagem salva; quantidade precisa ser inteira e maior que zero. */
export function parseStoredPackaging(raw: string | null): { productId: string; quantity: number } | null {
  try {
    const p = JSON.parse(raw || "null");
    if (p && typeof p.productId === "string" && p.productId && Number.isInteger(p.quantity) && p.quantity > 0) {
      return { productId: p.productId, quantity: p.quantity };
    }
    return null;
  } catch {
    return null;
  }
}

/** Mesma peça = mesmo produto + tamanho + cor (variante exata). */
export const isSameCartLine = (item: { id: string | number; size: string; colorVariantId?: string }, id: string | number, size: string, colorVariantId?: string) =>
  String(item.id) === String(id) && item.size === size && (item.colorVariantId || "") === (colorVariantId || "");

